import { useCallback } from 'react';
import { useOnCrmMessageTopic } from 'crm-message-bus/useOnCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { useAddObjectMutation } from '../localMutations/useAddObjectMutation';
import { OBJECT_DELETED } from '../localMutations/LocalMutationsStore';

/**
 * This hook sets up a listener for the OBJECT_DELETED message bus topic.
 * When an object is deleted, it adds a local mutation to mark the object
 * as deleted, which prevents it from showing in search results.
 *
 * This is especially useful for eagerly removing deleted objects from
 * search results, rather than waiting for search index updates.
 */
export function useSetupObjectDeletedSubscriber() {
  const addObjectMutation = useAddObjectMutation();
  const handleObjectDeleted = useCallback(payload => {
    const {
      objectTypeId,
      objectId
    } = payload;
    addObjectMutation({
      objectTypeId,
      objectId,
      mutation: OBJECT_DELETED
    });
  }, [addObjectMutation]);

  // Set up listener for OBJECT_DELETED events
  useOnCrmMessageTopic(TOPIC_NAMES.OBJECT_DELETED, handleObjectDeleted);
}